import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './slices/authSlice';
import messagesReducer from './slices/messagesSlice';
import { whatsappApi } from './services/whatsappApi';
import { catalogApi } from '../services/catalogApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    messages: messagesReducer,
    [whatsappApi.reducerPath]: whatsappApi.reducer,
    [catalogApi.reducerPath]: catalogApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      whatsappApi.middleware,
      catalogApi.middleware
    ),
});

// Optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Define the AppThunk type for async actions
export type AppThunk<ReturnType = void> = (
  dispatch: AppDispatch,
  getState: () => RootState
) => ReturnType | Promise<ReturnType>;
